import { FormControl, FormGroup } from "@angular/forms";
import { FilterInput } from "./filter-input";
import { TemplateRef } from '@angular/core';

export interface TableConfig<T> {
    headers: TableHeader[];
    properties: TableProperty[];
    data: T[];
    isFilterable: boolean;
    noResultsFound: string;
    showButtons: boolean;
    rowActions: RowActionType[];
    actionTooltipTemplate?: TemplateRef<any>;
}

export interface TableProperty {
    isDate?: boolean;
    titleCase?: boolean;
    translator?: (value: any) => string;
    name: string;
}

export interface TableHeader {
    name: string;
    isLarge?: boolean;
    filterInput?: FilterInput;
    sortId?: string; // database ID that is used to sort
}

export interface RowAction<T> {
    actionType: RowActionType;
    entity: T;
}

export enum RowActionType {
    View = "View",
    Delete = "Delete",
    Tooltip = "Tooltip",
}

export interface SortDetails {
    tableHeader: TableHeader;
    sortDirection: "ASC" | "DESC";
}

export function setTableControls(form: FormGroup, tableHeaders: TableHeader[]) {
    tableHeaders.forEach((header) => {
        form.addControl(header.filterInput.dbId, new FormControl(""));
    });
}

export function setFilterSelectOptions<T>(
    optionData: T[],
    viewValueProperty: string,
    valueProperty: string
) {
    const selectOptions = [{ viewValue: "All", value: "" }];
    optionData.forEach((data) => {
        const existingSelectOption = selectOptions.find(
            (selectOption) => selectOption.value === data[valueProperty]
        );

        if (!existingSelectOption) {
            selectOptions.push({
                viewValue: data[viewValueProperty],
                value: data[valueProperty],
            });
        }
    });
    return selectOptions;
}
